import React, {useEffect, useState} from 'react';
import {ReactComponent as BasketIcon} from '../../../../../../../assets/main/groups/online/basket.svg';
import {ReactComponent as DragIcon} from '../../../../../../../assets/main/groups/online/drag.svg';

import {Tabs} from "../../../test-edit/test-edit-item/test-descr-box/block-tabs/general/tabs/Tabs";
import {TextTab} from "../../../test-edit/test-edit-item/test-descr-box/block-tabs/text-tab/TextTab";
import {ListeningTab} from "../../../test-edit/test-create-search/test-descr-box/block-tabs/listening-tab/ListeningTab";
import {ImageTab} from "../../../test-edit/test-create-search/test-descr-box/block-tabs/image-tab/ImageTab";
import {useAppDispatch} from "common/hook";
import {setTabActive, TestItem} from "features/model/slice/create-test/create-test-form/createTestForm";
import {DraggableProvidedDragHandleProps} from "react-beautiful-dnd";


interface TestCreateDescrBoxProps {
    questionData?: TestItem;
    onDelete: (id: number) => void;
    dragHandleProps?: DraggableProvidedDragHandleProps | null;
}


export const TestCreateDescrBox: React.FC<TestCreateDescrBoxProps> = ({questionData, onDelete, dragHandleProps}) => {
    const dispatch = useAppDispatch();
    const [activeTab, setActiveTab] = useState(questionData?.tabType || '');


    const handleDelete = (id: number | undefined) => {
        if (id) {
            onDelete(id);
        }
    };


    useEffect(() => {
        if (questionData?.tabType) {
            setActiveTab(questionData.tabType);
        }
    }, [questionData?.id, questionData?.tabType]);


    const handleTabClick = (type: string) => {
        setActiveTab(type);
        if (questionData?.id) {
            dispatch(setTabActive({itemId: questionData.id, tabType: type}));
        }
    };

    const renderTabContent = () => {
        if (activeTab === 'textType') {
            return <TextTab questionData={questionData}/>;
        }
        if (activeTab === 'audioType') {
            return <ListeningTab questionData={questionData}/>;
        }
        if (activeTab === 'imageType') {
            return <ImageTab questionData={questionData}/>;
        }
        return null;
    };


    return (
        <div className="test-descr-box">
            <div className="test-descr-item">
                <div className="edit-test-heading">
                    <span
                        {...dragHandleProps}
                        className="js-reorder p-icon">
                        Изменить порядок
                        <span className="icon">
                            <DragIcon/>
                        </span>
                    </span>
                    <span className="delete-test" onClick={() => handleDelete(questionData?.id)}>
                        <BasketIcon/>
                    </span>
                    <Tabs activeTab={activeTab} handleTabClick={handleTabClick}/>
                </div>
                <div className="question-template">
                    <Tabs activeTab={activeTab} handleTabClick={handleTabClick}/>
                </div>
                <div className="tabs-content">
                    <div className="tab">
                        {renderTabContent()}
                    </div>
                </div>
            </div>
        </div>
    );
};
